
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class DNAHelixEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
        const spacing = (200 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);
        const curTime = time * 2 * config.parallaxSpeed;

        ctx.fillStyle = pc.color;
        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 2 * (config.parallaxScale || 1.0);

        for (let x = x1; x <= x2; x += spacing) {
            for (let y = y1; y <= y2; y += spacing) {
                const amp = spacing * 0.3 * (config.parallaxComplexity || 1.0);
                const freq = 0.05 / (config.parallaxScale || 1.0);
                const yOffset = y + Math.sin(x * freq + curTime) * amp;
                const yOffset2 = y + Math.sin(x * freq + curTime + Math.PI) * amp;
                
                const draw = () => {
                    ctx.beginPath();
                    ctx.arc(x, yOffset, 4 * (config.parallaxScale || 1.0), 0, Math.PI * 2);
                    ctx.fill();
                    ctx.beginPath();
                    ctx.arc(x, yOffset2, 4 * (config.parallaxScale || 1.0), 0, Math.PI * 2);
                    ctx.fill();
                    ctx.beginPath();
                    ctx.moveTo(x, yOffset);
                    ctx.lineTo(x, yOffset2);
                    ctx.stroke();
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
